import { builderFragment, localeFragment } from './fragments.gql'

export default `query LandingPageQuery(
  $locale: SiteLocale, $slug: String!, $id: ItemId
) {
  landingPage(${localeFragment}, filter: {
    OR: [
      { slug: { eq: $slug } }
      { id: { eq: $id } }
    ]
  }) {
    productPanel
    animatedHeader
    hidePageFooter
    narrowContent
    products {
      _modelApiKey
      sku
      title
      subTitle
      frameSwatchOverride
      lensSwatchOverride
      swatchIconOverride {
        url(imgixParams: {w: "50", h: "50"})
      }
      overrideLensName
      lensPart
      lensName
      stockManagedPart
      pageThemeOverride
      baseProduct {
        sku
      }
    }
    slug
    ${builderFragment}
  }

  localisedLandingPage: landingPage(filter: {
    OR: [
      { slug: { eq: $slug } }
      { id: { eq: $id } }
    ]
  }) {
    slug(locale: $locale)
  }
}`
